export class Material {
    id: string;
    color: string;
    name: string;
    active: boolean = true;
}
